import { render } from "./EditeFicheInventaire.vue?vue&type=template&id=6d727c28&scoped=true&ts=true"
import script from "./EditeFicheInventaire.vue?vue&type=script&lang=ts"
export * from "./EditeFicheInventaire.vue?vue&type=script&lang=ts"

import "./EditeFicheInventaire.vue?vue&type=style&index=0&id=6d727c28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d727c28"]])

export default __exports__